import React, { useEffect, useState } from 'react';

import { Box, Button, Stack, Typography } from '@mui/material';
import TableOccupancyPanel from '@/components/Base/TableOccupancyPanel';
import { listAllOccupancyDashboard } from '@/features/occupancyDashboard/api/listAll';
import RegisterClassCapacityModal from '@/components/Base/RegisterClassCapacityModal';
import FirstAccessModalPanel from '@/components/Base/FirstAccessModalPanel';
import useLoadingActions from '@/hooks/useLoadingActions';
import { groupBy } from 'lodash';
import ListItems from '@/components/Base/ListItems.tsx';
import { TitlePages } from '@/components/Base/TitlePage';
import { ArrowBack } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

export const OccupancyPanel = ({routeBack}) => {
  const [list, setList] = useState([]);
  const [data, setData] = useState([]);
  const [openModalClass, setOpenModalClass] = useState(false);
  const [rowSelected, setRowSelected] = useState(null);
  const [openFirstAccess, setOpenFirstAccess] = useState(() => {
    const hasSeenModal = localStorage.getItem('hasSeenOccupancyPanelModal');
    return !hasSeenModal;
  });
  const [series, setSeries] = useState([]);
  const [serieId, setSerieId] = useState<string | number>('all');
  const [turmas, setTurmas] = useState([]);
  const [turmaId, setTurmaId] = useState<string | number>('all');

  const [turnos, setTurnos] = useState([]);
  const [turnoId, setTurnoId] = useState<string | number>('all');
  const [activeFilter, setActiveFilter] = useState<string | null>(null);

  const { setIsLoading } = useLoadingActions();

  const listAll = async (filters) => {
    setIsLoading(true, 'Carregando dados...');

    const response = await listAllOccupancyDashboard(filters);

    if (activeFilter !== 'serie') {
      const seriesGroup = groupBy(response?.data, 'serie.serie_nome');
      setSeries(Object.keys(seriesGroup).map((key) => {
        // @ts-ignore
        const item = seriesGroup[key][0].serie
        return {
          id: item.serie_nome,
          name: item.serie_nome,
          label: key
        }
      }));
    }

    if (activeFilter !== 'turma') {
      const turmasGroup = groupBy(response?.data, 'serie.turma.nome');
      setTurmas(Object.keys(turmasGroup).map((key) => {
        // @ts-ignore
        const item = turmasGroup[key][0]?.serie?.turma
        return {
          id: item.nome,
          label: key,
          name: item.nome,
        }
      }));
    }

    if (activeFilter !== 'turno') {
      const turnosGroup = groupBy(response?.data, 'serie.turno.nome');
      setTurnos(Object.keys(turnosGroup).map((key) => {
        // @ts-ignore
        const item = turnosGroup[key][0]?.serie?.turno
        return {
          id: item.nome,
          label: key,
          name: item.nome,
        }
      }));
    }

    setList(response?.data);
    setIsLoading(false, '');
  };

  useEffect(() => {
    listAll({
      serieId: 'all', turmaId: 'all', turnoId: 'all'
    });
  }, []);

  useEffect(() => {
    if (list) {
      const dataMapped = list.map((item, key) => ({
        id: item.id,
        gradeLevel: item.serie.curso_nome,
        shift: item.serie.turno.nome,
        series: item.serie.serie_nome,
        class: item.serie.turma.nome,
        total: item.capacidade,
        reEnrollment: item.rematricula,
        newStudents: item.matricula,
        totalEnrollment: item.matricula + item.rematricula,
        vacancies: item.capacidade - item.ocupado,
        totalSupply: item.total_propostas,
        occupancyPercentage: item.ocupado / item.capacidade  ? ((item.ocupado / item.capacidade) * 100) : 0,
        enableStickyFooter: true,
      }));

      setData(dataMapped);
    }
  }, [list]);

  const onApplyFilter = () => {
    const serie = series.find((item) => String(item.id) === String(serieId))
    const turno = turnos.find((item) => String(item.id) === String(turnoId))
    const turma = turmas.find((item) => String(item.id) === String(turmaId))

    listAll({
      serieId,
      turmaId,
      turnoId,
      serie: serie?.name,
      turno: turno?.name,
      turma: turma?.name
    });
  }

  const navigate = useNavigate();

  return (
    <>
      <FirstAccessModalPanel
        open={openFirstAccess}
        handleClose={() => {
          localStorage.setItem('hasSeenOccupancyPanelModal', 'true');
          setOpenFirstAccess(false);
        }}
      />
      {openModalClass && (
        <RegisterClassCapacityModal
          open={openModalClass}
          handleClose={() => {
            setOpenModalClass(false);
          }}
          submit={() => console.log('teste')}
          rowSelected={rowSelected}
          onRefresh={onApplyFilter}
        />
      )}
      <Stack flexDirection={'row'} alignItems={'center'} justifyContent={'space-between'}>
      <Stack flexDirection={'row'} alignItems={'center'} gap={4}>
        <ArrowBack sx={{  cursor: 'pointer' }} onClick={() => navigate(routeBack)} />
          <TitlePages title={'Painel de ocupação'}/>
      </Stack>
      </Stack>
      <Box
        padding={'15px'}
        sx={{
          border: '1px solid rgba(176, 176, 176, 1)',
          background: '#fff',
          borderRadius: '14px',
        }}
      >
        <Box
          sx={{
            backgroundColor: '#fff',
            display: 'flex',
            gap: '16px',
            alignItems: 'end',
            p: '8px',
            '.MuiInputBase-input': { padding: '5px', color: '#000' },
            '.MuiButtonBase-root': { color: '#000' },
            '.MuiTypography-root': { color: '#000' },
          }}
        >
          <Box maxWidth={'250px'} width={'100%'}>
            <ListItems
              name={'serie_id'}
              options={series}
              label={'Série'}
              value={serieId}
              onChange={(e) => {
                setSerieId(e.target.value)
                setActiveFilter('serie')
              }}
            />
          </Box>

          <Box maxWidth={'250px'} width={'100%'}>
            <ListItems
              name={'turma_id'}
              options={turmas} label={'Turma'}
              value={turmaId}
              onChange={(e) => {
                setTurmaId(e.target.value)
                setActiveFilter('turma')
              }}
            />
          </Box>

          <Box maxWidth={'250px'} width={'100%'}>
            <ListItems
              name={'turno_id'}
              options={turnos}
              label={'Turno'}
              value={turnoId}
              onChange={(e) => {
                setTurnoId(e.target.value)
                setActiveFilter('turno')
              }}
            />
          </Box>

          <Button
            sx={{
              maxWidth: '188px',
              minWidth: '188px',
              p: '0 5px',
              borderRadius: '24px',
              fontSize: '14px',
              height: '37px',
              color: '#fff !important',
              width: '188px',
              weight: '600',
              background: '#15AB51',
              textTransform: 'capitalize'
            }}
            variant="contained"
            onClick={onApplyFilter}
          >
            Filtrar
          </Button>
        </Box>

        <TableOccupancyPanel data={data} setOpenModalClass={setOpenModalClass} setRowSelected={setRowSelected} />
      </Box>
    </>
  );
};
